export enum ErrorType {
  NETWORK = "Network",
  COMMERCIAL_BACKEND = "CommercialBackend",
  CYBWELL = "Cybwell",
}
